import React, {useState} from "react";
import {Link, useLocation} from "react-router-dom";
import {FaCopy, FaLink} from "react-icons/fa";
import {PiechartPreview} from "./render";

export const Piechart = () => {
    const [copied, setCopied] = useState(false);

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    const [environment, setEnvironment] = useState(queryParams.get("environment") || "DEV");

    const [labels, setLabels] = useState(queryParams.get("labels") || "label1,label2,label3");
    const [values, setValues] = useState(queryParams.get("values") || "45.23,334.12,11.4");
    const [showLegend, setShowLegend] = useState(queryParams.get("showLegend") || "Y");
    const [legendPosition, setLegendPosition] = useState(queryParams.get("legendPosition") || "bottom");
    const [type, setType] = useState(queryParams.get("type") || "pie");
    const [seriesColor, setSeriesColor] = useState(queryParams.get("seriesColor") || "0066FF,01087A,0000FF,D6E4F9,E4F3FF");
    const [fontFamily, setFontFamily] = useState(queryParams.get("fontFamily") || "Arial, sans-serif");

    const [colorBackground, setColorBackground] = useState(queryParams.get("colorBackground") || "#FFFFFF");



    const handleCopy = () => {
        navigator.clipboard.writeText(linkToCopy);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    const linkToCopy =
        process.env.REACT_APP_FRONT_URL + "/piechart?na=1"
        + "&environment=PROD"
        + "&labels=" + labels
        + "&values=" + values
        + "&showLegend=" + showLegend
        + "&legendPosition=" + legendPosition
        + "&type=" + type
        + "&seriesColor=" + seriesColor
        + "&fontFamily=" + fontFamily
        + "&colorBackground=" + colorBackground;


    return (
        <div className="flex flex-col items-center justify-center" style={{width:'100%',backgroundColor:colorBackground}}>
            {environment=== "DEV" && (
                <>
                    <h1 style={{fontSize: 40, fontWeight: 'bold'}}>
                        Pie Chart Card Component
                    </h1>
                    <br/><br/>
                    <h3 className="text-lg font-semibold mb-3">QUERY PARAMETERS</h3>
                    <br/>

                    <h3 className="text-md font-semibold mb-3 mt-10">Chart configuration</h3>
                    <div className="flex flex-wrap items-start justify-start gap-4 w-full">

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">labels</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    secciones, separadas por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setLabels(e.target.value)}
                                        value={labels}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">values</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Valores, separadas por coma
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setValues(e.target.value)}
                                        value={values}
                                    />
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">seriesColor</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Colores de las series
                                    <br/>
                                    <input
                                        type="text"
                                        className="w-full px-4 py-2 border border-gray-300 rounded-md shadow-sm focus:ring-indigo-500 focus:border-indigo-500 focus:outline-none text-gray-700"
                                        onChange={(e) => setSeriesColor(e.target.value)}
                                        value={seriesColor}
                                    />
                                </p>
                            </div>
                        </div>


                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">showLegend</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Muestra leyenda con las etiquetas
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setShowLegend(e.target.value)}
                                        value={showLegend}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">showLegend</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Muestra leyenda con las etiquetas
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setType(e.target.value)}
                                        value={type}>
                                        <option value="pie">pie</option>
                                        <option value="donut">donut</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">showLegend</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Muestra leyenda con las etiquetas
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setShowLegend(e.target.value)}
                                        value={showLegend}>
                                        <option value="Y">Y</option>
                                        <option value="N">N</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">legendPosition</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Ubicacion de la leyenda
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setLegendPosition(e.target.value)}
                                        value={legendPosition}>
                                        <option value="right">right</option>
                                        <option value="left">left</option>
                                        <option value="bottom">bottom</option>
                                        <option value="top">top</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                        <div className="h-auto rounded overflow-hidden  bg-white" style={{width: 400}}>
                            <div className="h-full px-6 py-4 flex flex-col">
                                <div className="font-bold text-xl mb-2">fontFamily</div>
                                <p className="text-gray-700 text-base flex-grow">
                                    Tipografia
                                    <br/>
                                    <select
                                        className="block w-full mt-1 px-3 py-2 bg-white border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
                                        onChange={(e) => setFontFamily(e.target.value)}
                                        value={fontFamily}>
                                        <option value="Arial, sans-serif">Arial, sans-serif</option>
                                        <option value="Courier New, monospace">Courier New, monospace</option>
                                        <option value="Helvetica, sans-serif">Helvetica, sans-serif</option>
                                        <option value="Verdana, sans-serif">Verdana, sans-serif</option>
                                        <option value="Tahoma, sans-serif">Tahoma, sans-serif</option>
                                        <option value="Trebuchet MS, sans-serif">Trebuchet MS, sans-serif</option>
                                        <option value="Open Sans, sans-serif">Open Sans, sans-serif</option>
                                        <option value="Roboto, sans-serif">Roboto, sans-serif</option>
                                    </select>
                                </p>
                            </div>
                        </div>

                    </div>
                    <h3 className="text-lg font-semibold mb-3">PREVIEW</h3>

                    <br/><br/>
                </>)}

            <PiechartPreview
                colorBackground={colorBackground}
                values={values}
                labels={labels}
                showLegend={showLegend}
                legendPosition={legendPosition}
                type={type}
                seriesColor={seriesColor}
                fontFamily={fontFamily}
            />


            {environment === "DEV" && (
                <div>
                    <br/><br/>
                    <div className="flex items-center mb-5">
                        <button
                            onClick={handleCopy}
                            className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600"
                        >
                            <FaCopy className="mr-2"/>
                            {copied ? "Copied!" : "Copy Link"}
                        </button>

                        <Link to={"/"}>
                            <button className="mr-4 bg-blue-500 text-white p-2 rounded-lg flex items-center hover:bg-blue-600" >
                                <FaLink className="mr-2"/>
                                Go to Home
                            </button>
                        </Link>
                    </div>

                </div>
            )}
        </div>

    );
};
